// API configuration utility
// In production, uses relative paths (same origin)
// In development, uses REACT_APP_BACKEND_URL from .env

function getApiUrl() {
  // Check runtime config first (set by config.js in production)
  if (window.__RUNTIME_CONFIG__?.REACT_APP_BACKEND_URL) {
    const url = window.__RUNTIME_CONFIG__.REACT_APP_BACKEND_URL;
    return url ? `${url}/api` : '/api';
  }
  // Fall back to build-time env var
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  return backendUrl ? `${backendUrl}/api` : '/api';
}

export const API_URL = getApiUrl();
